import React from 'react'
import BlazonSticker from 'app/common/blazon/sticker/BlazonSticker'
import { H5, Text } from 'app/common/typography'
import { colors } from 'shared/assets/styles'
import type { Blazon } from 'shared/types'
import styled from 'styled-components'

const { grey } = colors

type Props = {
    blazon: Blazon
}

const BlazonModalHeader = (props: Props) => {
    const { blazon } = props
    const { title, description, imageUrl } = blazon

    return (
        <Root>
            <BlazonStickerContainer>
                <BlazonSticker imageUrl={imageUrl} size="big" />
            </BlazonStickerContainer>
            <H5>{title}</H5>
            <Paragraph>
                <Description>{description}</Description>
            </Paragraph>
        </Root>
    )
}

const Root = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 24px;
    padding: 0 16px;
`

const BlazonStickerContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 16px;
`

const Paragraph = styled.p`
    text-align: center;
`

const Description = styled(Text)`
    white-space: pre-line;
    color: ${grey};
`

export { BlazonModalHeader }
